(() => {
  if (customElements.get('solutello-home')) return;
  class SolutelloHome extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('.sh-dialog');
      this.content = this.querySelector('[data-sh-dialog-content]');
      if (!this.dialog || !this.content) return;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-sh-open]');
        if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0 && typeof this.dialog.showModal === 'function') {
          const template = this.querySelector(`#${CSS.escape(link.dataset.shOpen)}`);
          if (!template) return;
          event.preventDefault();
          this.returnFocus = link;
          this.content.replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();
          this.querySelector('[data-sh-close]')?.focus();
        }
        if (event.target.closest('[data-sh-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.pauseVideos();
        this.content.replaceChildren();
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseVideos(); }, options);
      document.addEventListener('shopify:section:unload', (event) => { if (event.detail?.sectionId === this.dataset.sectionId) this.cleanup(); }, options);
      this.addEventListener('play', (event) => {
        this.querySelectorAll('video').forEach((video) => { if (video !== event.target) video.pause(); });
      }, { ...options, capture: true });
    }
    pauseVideos() { this.querySelectorAll('video').forEach((video) => video.pause()); }
    cleanup() {
      this.pauseVideos();
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort();
      this.content?.replaceChildren();
    }
    disconnectedCallback() { this.cleanup(); }
  }
  customElements.define('solutello-home', SolutelloHome);
})();
